import React from "react"
import { Media } from "../../../models/document"

type EmbedProps = {
	media: Media
	size?: "small" | "medium" | "large"
}

function NormalizeMedia({ media, size }: EmbedProps) {
	const width = "100%"
	const height = "100%"
	if (media.type === "video") {
		if (!media.url) return null

		return (
			<video width={width} height={height} controls poster={media.thumbnail ?? ""}>
				<source src={media.url} type="video/mp4" />
				<source src={media.url} type="video/ogg" />
				<source src={media.url} type="video/webm" />
				Your browser does not support the video tag.
			</video>
		)
	}

	if (media.type === "image") {
		return <img src={media.url} alt={media?.description ?? "an image"} width={width} />
	}
	return <></>
}

export default NormalizeMedia
